import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ButtonWrapper from './ButtonWrapper';
import { MultipleSearchSelectionWrapper } from 'react-lib/dist/components-es';
/*source https://www.npmjs.com/package/react-multiselect-checkboxes*/

const CommonMultipleSearchSelectionWrapper = props => {
  const onChange = (selectedOption, actionType) => {
    //on clear, force add the default values
    if (actionType === 'clear' && props.clearDefaultValues)
      selectedOption = props.optionsList.filter(o => props.clearDefaultValues.includes(o.value));
    props.onChange(selectedOption, actionType);
  };

  return (
    <>
      <div className={props.isClearable ? 'displayInlineBlock componentWithRightMargin' : ''}>
        <MultipleSearchSelectionWrapper {...props} onChange={onChange} />
      </div>
      {props.isClearable && (
        <div className="displayInlineBlock">
          <ButtonWrapper onClick={() => onChange([], 'clear')} label={props.cleanButtonLabel} />
        </div>
      )}
    </>
  );
};

CommonMultipleSearchSelectionWrapper.propTypes = {
  optionsList: PropTypes.array.isRequired,
};

CommonMultipleSearchSelectionWrapper.defaultProps = {
  isClearable: false,
  cleanButtonLabel: 'select.multiple.input.clean.all',
  placeholder: 'select.multiple.input.default.placeholder',
};

export default withTranslation()(CommonMultipleSearchSelectionWrapper);
